import { BehaviorSubject, Observable, timer } from 'rxjs';
import { catchError, distinctUntilKeyChanged, map, switchMap } from 'rxjs/operators';

import { xhrApi } from './xhr.api';
import { ApiResult } from '../entities';
import { ResponseError } from '../../utils';
import { environment } from '../../../environments/environment';
import { DesktopService } from '../../services/desktop.service';


export const eventsSubjects: Map<string, BehaviorSubject<ApiResult['datas']>> = new Map<string, BehaviorSubject<ApiResult['datas']>>();
const playerId = localStorage.getItem('playerId');
let eventSource: EventSource = null;

const parseMessageFromEventSource = (event: MessageEvent) => {
  try {
    if (event) {
      localStorage.setItem('SSE', event.data);
      return JSON.parse(event.data);
    }
  } catch (err) {
    console.error(err);
    throw new Error('player.status.error');
  }
};

const pollingFakeSse$ = (path: string): Observable<{data: string}> =>
  timer(0, 5000).pipe(
    switchMap(() => xhrApi.get(path)),
    catchError(err => { throw new ResponseError(err.message, err.status); }),
    map(datas => ({ data: JSON.stringify({ datas }) })),
    distinctUntilKeyChanged('data'),
  );

let callStatus = false;
export const sseApi = {
  close<T>() {
    if (eventSource && eventsSubjects) {
      eventsSubjects.clear();
      eventSource.close();
    }
  },
  startStatus<T>(path: string, type: string = 'player-status'): Observable<T> {

    if (environment.enableDesktopMode) {
      if (!eventsSubjects.has(path)) {
        eventsSubjects.set(path, new BehaviorSubject(null));
      }
      if (callStatus) {
        return eventsSubjects.get(path).asObservable();
      }
      callStatus = true;
      DesktopService.getStatus().subscribe( message => {
        if (message?.datas?.fading) {
          return;
        }
        const event = new CustomEvent(type, { detail: { data: message } });
        localStorage.setItem('SSE', JSON.stringify(message));
        document.dispatchEvent(event);
        eventsSubjects.get(path).next(message);
      },
        error => {
          const event = new CustomEvent(type, { detail: undefined });
          document.dispatchEvent(event);
        }

        );
      setTimeout(() => {
        callStatus = false;
        sseApi.startStatus( '/sse-status/' + playerId + '?ngsw-bypass=true');
      }, 5000);
      return eventsSubjects.get(path).asObservable();
    }

    const oldPath = eventsSubjects.keys().next();
    if (oldPath && oldPath.value && oldPath.value !== path) {
      sseApi.close();
    }
    if (!eventsSubjects.has(path)) {
      eventsSubjects.set(path, new BehaviorSubject(null));
      eventSource = new EventSource(environment.remoteApi + path);
      eventSource.addEventListener<any>(type, message => {
        const { datas } = parseMessageFromEventSource(message);
        // Create the event
        const event = new CustomEvent(type, { detail: message });
        // Dispatch/Trigger/Fire the event
        document.dispatchEvent(event);
        localStorage.setItem('errorTimeout', '0');
        eventsSubjects.get(path).next(datas);
      });
      eventSource.addEventListener<any>('command', message => {
        const { datas } = parseMessageFromEventSource(message);
        // Create the event
        const event = new CustomEvent('command', { detail: message });
        // Dispatch/Trigger/Fire the event
        document.dispatchEvent(event);
        eventsSubjects.get(path).next(datas);
      });
      eventSource.onerror = (error) => {
        let errorTimeout = Number(localStorage.getItem('errorTimeout'));
        if (!errorTimeout) {
          errorTimeout = 0;
        }
        localStorage.setItem('errorTimeout', Math.min(errorTimeout + 5000, 55000).toString());
        setTimeout(() => {

          console.error(error);
          const player = localStorage.getItem('playerId');
          const resort = localStorage.getItem('resortId');
          sseApi.close();
          sseApi.startStatus( '/sse-status/' + player + '/' + resort + '?ngsw-bypass=true');
        }, 5000 + errorTimeout);

      };
      // pollingFakeSse$(path).pipe(
      //   map(parseMessageFromEventSource),
      //   pluck('datas'),
      // ).subscribe(
      //   data => eventsSubjects.get(path).next(data),
      //   () => {}, () => eventsSubjects.delete(path)
      // );
    }
    return eventsSubjects.get(path).asObservable();
  }
};
